

// Common to every API responses

import { RequestTypeEnum } from './toast';

interface ApiResponseStatus {
    text: string, // 'success' | 'error', //used for toast
    requestType?: RequestTypeEnum // | string, // E.g 'getFleets', used for toast msg
    code: number, // Useful for debug and maintainance, can be undefined for put (e.g remove vehicles from fleet)
}

export type { ApiResponseStatus };

export interface PaginationData {
    page: number,
    pageSize: number,
    pageCount: number,
    total: number
}

export type ApiEntity<T> = T & {
    documentId: string;
    id?: number | string;
};

export interface ApiEntities<T> {
    data: ApiEntity<T>[];
}

export function mapApiEntity<T>(entity?: ApiEntity<T>): T {
    if (!entity) return null as T;

    const { documentId, id, ...rest } = entity as any;
    return { ...rest, id: id ?? documentId, documentId } as T;
}

export function mapApiEntities<T>(entities?: ApiEntities<T>): T[] {
    if (entities?.data && Array.isArray(entities.data)) return entities.data.map(item => mapApiEntity<T>(item));
    if (entities && Array.isArray(entities)) return entities.map(item => mapApiEntity<T>(item));
    return [];
}

interface ApiResponseMeta {
    pagination: PaginationData;
}

export type { ApiResponseMeta };

export interface AbstractReturnType {
    meta?: ApiResponseMeta;
    status: ApiResponseStatus;
}

export interface ApiResponseSuccess {
    success: {
        message: string,
    }
}